import createMetas from './createMetas';

const DEFAULT_THEMING_COLOR = '#34b196';

const PROPERTIES_MAP = {
  themeColor: 'theme-color'
};

const DEFAULT_PROPERTIES = {
  themeColor: DEFAULT_THEMING_COLOR
};

export const createThemeMetas = (props = {}) =>
  createMetas(props, DEFAULT_PROPERTIES, PROPERTIES_MAP);

export default {
  createThemeMetas,
  DEFAULT_THEMING_COLOR
};
